import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { ResponseApi, PagedResultApi } from '../models/response-api';
import { ConfirmarPedidoPayload, ConfirmarPedidoResponse, PedidoDetalleApi, PedidoListApi, TransaccionApi } from '../models/api/pedido-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class PedidoService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/pedido/';

    confirmarPedido(body: ConfirmarPedidoPayload): Observable<ConfirmarPedidoResponse> {
        return this.http.post<ResponseApi<ConfirmarPedidoResponse>>(this.url + 'confirmar-pedido', body).pipe(
            map((res) => this.requireData(res))
        );
    }

    rastrearPedido(numeroPedido: string, telefono: string): Observable<PedidoDetalleApi> {
        const params = new HttpParams().set('numeroPedido', numeroPedido).set('telefono', telefono);
        return this.http.get<ResponseApi<PedidoDetalleApi>>(this.url + 'rastrear-pedido', { params }).pipe(
            map((res) => this.requireData(res))
        );
    }
    listMisPedidos(pageNumber = 1, pageSize = 9): Observable<PagedResultApi<PedidoListApi>> {
        const params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);
        return this.http.get<ResponseApi<PagedResultApi<PedidoListApi>>>(this.url + 'list-mis-pedidos', { params }).pipe(
            map((res) => this.requirePage(res, pageNumber, pageSize))
        );
    }

    getPedido(pedidoUuid: string): Observable<PedidoDetalleApi> {
        return this.http.get<ResponseApi<PedidoDetalleApi>>(this.url + 'get-pedido/' + pedidoUuid).pipe(
            map((res) => this.requireData(res))
        );
    }

    listPedidosStaff(estadoCodigo?: string, key?: string, pageNumber = 1, pageSize = 9): Observable<PagedResultApi<PedidoListApi>> {
        let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);
        if (estadoCodigo) {
            params = params.set('estadoCodigo', estadoCodigo);
        }
        if (key?.trim()) {
            params = params.set('key', key.trim());
        }
        return this.http.get<ResponseApi<PagedResultApi<PedidoListApi>>>(this.url + 'list-pedidos-staff', { params }).pipe(
            map((res) => this.requirePage(res, pageNumber, pageSize))
        );
    }

    cambiarEstado(pedidoUuid: string, estadoCodigo: string, comentario?: string | null): Observable<TransaccionApi> {
        return this.http.put<ResponseApi<TransaccionApi>>(this.url + 'cambiar-estado/' + pedidoUuid, { estadoCodigo, comentario }).pipe(
            map((res) => this.requireData(res))
        );
    }

    private requireData<T>(res: ResponseApi<T>): T {
        if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
            throw new Error(this.readError(res));
        }
        return res.data;
    }

    private requirePage(res: ResponseApi<PagedResultApi<PedidoListApi>>, pageNumber: number, pageSize: number): PagedResultApi<PedidoListApi> {
        if (res.success === Constante.REQUEST_STATUS_VACIO) {
            return { total: 0, page: pageNumber, pageSize, data: [] };
        }
        return this.requireData(res);
    }

    private readError(res: ResponseApi<unknown>): string {
        const errors = res.errors as { message?: string }[] | null;
        return errors?.[0]?.message || res.message || 'Ocurrió un error inesperado.';
    }
}
